/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFolderDownload = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m10.618 2 2 4H22v16H2V2zM4 20h16V8h-8.618l-2-4H4z" />
        <path d="M13 10v4.086l1.793-1.793 1.414 1.414L12 17.914l-4.207-4.207 1.414-1.414L11 14.086V10z" />
      </g>
    </g>
  </Icon>
);
export { SvgFolderDownload as FolderDownload };
